module.exports = __webpack_public_path__ + "media/images/new_landing/people/petr-sadilek-c3c5baff30f5d3c6d6444749ad4d1996.jpg";